export default function determineTarget( element ) {
	const target = element.dataset.target ?? element.getAttribute( 'aria-controls' );
	return document.getElementById( target );
}

